import { RouteCodeOptions } from '@strata/constants';
import { Grid, PrimaryData } from '@strata/react-grid';

import { ListPageHeader } from 'components/ListPageHeader';

const sortProperties = [{ id: 'value', desc: false }];

const columns = [
    {
        header: 'Route Code',
        accessorKey: 'value',
        size: 75,
        cell: ({ getValue }) => <PrimaryData data={getValue()} />,
    },
    {
        header: 'Display Name',
        accessorKey: 'name',
        size: 100,
    },
    {
        header: 'Description',
        accessorKey: 'secondaryData',
        size: 300,
    },
];

export const RouteCodes = () => (
    <div className="sds_main-content__container">
        <ListPageHeader pageTitle="Route Codes" />
        <Grid data={RouteCodeOptions} columns={columns} sortProperties={sortProperties} />
    </div>
);
